import { gql } from 'src/generated/gql';

export const LOAD_PATIENT_HEADER_PATIENT = gql(`
  query LoadPatientHeaderPatient($id: ID!) {
    menuPatient(id: $id) {
      id
      consentsToVoicemails
      dob
      firstName
      homeAddress {
        street1
        street2
        city
        state
        zip
      }
      isOnPayorWaitlist
      lastName
      phone
      preferredName
      profilePhoto
      pronouns
      timezone
      verificationStatus
      zendeskUrl
      picEligibilityDate
    }
  }
`);
